
// import React, { useState, useEffect } from 'react';
// import { FaEdit, FaTrash, FaUserTie, FaCogs } from 'react-icons/fa';
// import axios from 'axios';
// import "./ResponsiveTable.css";
// import { Base_Url } from '../config';
// import { Link } from 'react-router-dom';

// const ResponsiveTable = () => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [people, setPeople] = useState([]);

//   // Fetch all profiles
//   const fetchProfiles = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/profiles`);
//       setPeople(response.data);
//     } catch (error) {
//       console.error('Error fetching profiles:', error);
//     }
//   };

//   useEffect(() => {
//     fetchProfiles();
//   }, []);

//   // Separate handler for HOD toggle
//   const handleHodToggle = async (id) => {
//     try {
//       const person = people.find(p => p.id === id);
//       const updatedValue = !person.show_hod;

//       if (updatedValue) {
//         // First, set all profiles' show_hod to false in the database
//         const updatePromises = people
//           .filter(p => p.show_hod)
//           .map(p => axios.put(`${Base_Url}/profile/${p.id}`, { show_hod: false }));
        
//         await Promise.all(updatePromises);

//         // Then set the selected profile as HOD
//         await axios.put(`${Base_Url}/profile/${id}`, { show_hod: true });

//         // Update local state
//         setPeople(prevPeople =>
//           prevPeople.map(p => ({
//             ...p,
//             show_hod: p.id === id
//           }))
//         );
//       } else {
//         // If turning off HOD, just update this profile
//         await axios.put(`${Base_Url}/profile/${id}`, { show_hod: false });
        
//         // Update local state
//         setPeople(prevPeople =>
//           prevPeople.map(p => ({
//             ...p,
//             show_hod: p.id === id ? false : p.show_hod
//           }))
//         );
//       }
//     } catch (error) {
//       console.error('Error updating HOD status:', error);
//       // Refresh the data to ensure consistency
//       fetchProfiles();
//     }
//   };

//   // Handle toggle for other fields
//   const handleToggle = async (id, field) => {
//     if (field === 'show_hod') {
//       return handleHodToggle(id);
//     }

//     try {
//       const person = people.find(p => p.id === id);
//       const updatedValue = !person[field];

//       await axios.put(`${Base_Url}/profile/${id}`, {
//         [field]: updatedValue
//       });

//       setPeople(prevPeople => 
//         prevPeople.map(person => {
//           if (person.id === id) {
//             return { ...person, [field]: updatedValue };
//           }
//           return person;
//         })
//       );
//     } catch (error) {
//       console.error('Error updating profile:', error);
//       // Refresh the data to ensure consistency
//       fetchProfiles();
//     }
//   };

//   // Handle delete profile
//   const handleDelete = async (id) => {
//     if (window.confirm('Are you sure you want to delete this profile?')) {
//       try {
//         await axios.delete(`${Base_Url}/profile/${id}`);
//         setPeople(prevPeople => prevPeople.filter(person => person.id !== id));
//       } catch (error) {
//         console.error('Error deleting profile:', error);
//       }
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <div className="card">
//         <div className="card-header bg-white">
//           <div className="d-flex justify-content-between align-items-center">
//             <h5 className="card-title mb-0">CSC People</h5>
//             <Link to="/add-profile" className="btn btn-primary btn-sm">
//               Add New Profile
//             </Link>
//           </div>
//         </div>
//         <div className="card-body">
//           <div className="table-responsive">
//             <table className="table table-hover table-bordered">
//               <thead className="table-light">
//                 <tr>
//                   <th scope="col">ID</th>
//                   <th scope="col">Name</th>
//                   <th scope="col">UserID</th>
//                   <th scope="col">Designation</th>
//                   <th scope="col">HOD Status</th>
//                   <th scope="col">Show in Display</th>
//                   <th scope="col">Retired</th>
//                   <th scope="col">IRD</th>
//                   <th scope="col">Outsourced</th>
//                   <th scope="col">Technical Staff</th> {/* NEW COLUMN ADDED */}
//                   <th scope="col">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {people.map((person) => (
//                   <tr key={person.id} className={person.show_hod ? 'table-primary' : ''}>
//                     <td>{person.id}</td>
//                     <td>
//                       <div className="d-flex align-items-center">
//                         {person.image_path && (
//                           <img 
//                             src={`${Base_Url}/${person.image_path}`} 
//                             alt={person.name}
//                             className="rounded-circle me-2"
//                             style={{ width: '30px', height: '30px', objectFit: 'cover' }}
//                           />
//                         )}
//                         <div className="d-flex align-items-center">
//                           {person.name} 
//                           {person.show_hod == 1 && (
//                             <FaUserTie className="ms-2 text-primary" title="Head of Department" />
//                           )}
//                           {person.technicalstaff == 1 && ( /* NEW ICON ADDED */
//                             <FaCogs className="ms-2 text-success" title="Technical Staff" />
//                           )}
//                         </div>
//                       </div>
//                     </td>
//                     <td className='text-lowercase'>{person.userid}</td>
//                     <td>{person.designation}</td>
//                     <td>
//                       <div className="d-flex align-items-center justify-content-between">
//                         <span className={`badge ${person.show_hod ? 'bg-primary' : 'bg-secondary'}`}>
//                           {person.show_hod ? 'HOD' : 'Faculty'}
//                         </span>
//                         <div className="ms-2">
//                           <div className="form-check form-switch d-inline-block">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               role="switch"
//                               checked={person.show_hod}
//                               onChange={() => handleToggle(person.id, 'show_hod')}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="d-flex align-items-center justify-content-between">
//                         <span className={`badge ${person.show_in_display ? 'bg-success' : 'bg-danger'}`}>
//                           {person.show_in_display ? 'Yes' : 'No'}
//                         </span>
//                         <div className="ms-2">
//                           <div className="form-check form-switch d-inline-block">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               role="switch"
//                               checked={person.show_in_display}
//                               onChange={() => handleToggle(person.id, 'show_in_display')}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="d-flex align-items-center justify-content-between">
//                         <span className={`badge ${person.isretired ? 'bg-warning' : 'bg-info'}`}>
//                           {person.isretired ? 'Retired' : 'Active'}
//                         </span>
//                         <div className="ms-2">
//                           <div className="form-check form-switch d-inline-block">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               role="switch"
//                               checked={person.isretired}
//                               onChange={() => handleToggle(person.id, 'isretired')}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="d-flex align-items-center justify-content-between">
//                         <span className={`badge ${person.ird ? 'bg-success' : 'bg-secondary'}`}>
//                           {person.ird ? 'Yes' : 'No'}
//                         </span>
//                         <div className="ms-2">
//                           <div className="form-check form-switch d-inline-block">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               role="switch"
//                               checked={person.ird}
//                               onChange={() => handleToggle(person.id, 'ird')}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="d-flex align-items-center justify-content-between">
//                         <span className={`badge ${person.outsource ? 'bg-success' : 'bg-secondary'}`}>
//                           {person.outsource ? 'Yes' : 'No'}
//                         </span>
//                         <div className="ms-2">
//                           <div className="form-check form-switch d-inline-block">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               role="switch"
//                               checked={person.outsource}
//                               onChange={() => handleToggle(person.id, 'outsource')}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td> {/* NEW COLUMN FOR TECHNICAL STAFF */}
//                       <div className="d-flex align-items-center justify-content-between">
//                         <span className={`badge ${person.technicalstaff ? 'bg-success' : 'bg-secondary'}`}>
//                           {person.technicalstaff ? 'Yes' : 'No'}
//                         </span>
//                         <div className="ms-2">
//                           <div className="form-check form-switch d-inline-block">
//                             <input
//                               className="form-check-input"
//                               type="checkbox"
//                               role="switch"
//                               checked={person.technicalstaff}
//                               onChange={() => handleToggle(person.id, 'technicalstaff')}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <Link
//                           to={`/edit-profile/${person.id}`} 
//                           className="btn btn-sm btn-outline-primary"
//                         >
//                           <FaEdit />
//                         </Link>
//                         <button 
//                           className="btn btn-sm btn-outline-danger"
//                           onClick={() => handleDelete(person.id)}
//                         >
//                           <FaTrash />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResponsiveTable;

import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaUserTie, FaCogs, FaSort } from 'react-icons/fa';
import axios from 'axios';
import "./ResponsiveTable.css";
import { Base_Url } from '../config';
import { Link } from 'react-router-dom';

const ResponsiveTable = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [people, setPeople] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'order', direction: 'asc' });

  // Fetch all profiles
  const fetchProfiles = async () => {
    try {
      const response = await axios.get(`${Base_Url}/profiles`);
      setPeople(response.data);
    } catch (error) {
      console.error('Error fetching profiles:', error);
    }
  };

  useEffect(() => {
    fetchProfiles();
  }, []);

  // Sort function for order field
  const sortPeople = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Apply sorting
  const sortedPeople = React.useMemo(() => {
    if (!people.length) return [];
    
    const sorted = [...people].sort((a, b) => {
      // Handle null/undefined values by treating them as 0
      const aValue = a[sortConfig.key] ? parseInt(a[sortConfig.key]) : 0;
      const bValue = b[sortConfig.key] ? parseInt(b[sortConfig.key]) : 0;
      
      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
    return sorted;
  }, [people, sortConfig]);

  // Separate handler for HOD toggle
  const handleHodToggle = async (id) => {
    try {
      const person = people.find(p => p.id === id);
      const updatedValue = !person.show_hod;

      if (updatedValue) {
        // First, set all profiles' show_hod to false in the database
        const updatePromises = people
          .filter(p => p.show_hod)
          .map(p => axios.put(`${Base_Url}/profile/${p.id}`, { show_hod: false }));
        
        await Promise.all(updatePromises);

        // Then set the selected profile as HOD
        await axios.put(`${Base_Url}/profile/${id}`, { show_hod: true });

        // Update local state
        setPeople(prevPeople =>
          prevPeople.map(p => ({
            ...p,
            show_hod: p.id === id
          }))
        );
      } else {
        // If turning off HOD, just update this profile
        await axios.put(`${Base_Url}/profile/${id}`, { show_hod: false });
        
        // Update local state
        setPeople(prevPeople =>
          prevPeople.map(p => ({
            ...p,
            show_hod: p.id === id ? false : p.show_hod
          }))
        );
      }
    } catch (error) {
      console.error('Error updating HOD status:', error);
      // Refresh the data to ensure consistency
      fetchProfiles();
    }
  };

  // Handle toggle for other fields
  const handleToggle = async (id, field) => {
    if (field === 'show_hod') {
      return handleHodToggle(id);
    }

    try {
      const person = people.find(p => p.id === id);
      const updatedValue = !person[field];

      await axios.put(`${Base_Url}/profile/${id}`, {
        [field]: updatedValue
      });

      setPeople(prevPeople => 
        prevPeople.map(person => {
          if (person.id === id) {
            return { ...person, [field]: updatedValue };
          }
          return person;
        })
      );
    } catch (error) {
      console.error('Error updating profile:', error);
      // Refresh the data to ensure consistency
      fetchProfiles();
    }
  };

  // Handle order field update
  const handleOrderChange = async (id, newOrder) => {
    try {
      await axios.put(`${Base_Url}/profile/${id}`, {
        order: newOrder
      });

      setPeople(prevPeople => 
        prevPeople.map(person => {
          if (person.id === id) {
            return { ...person, order: newOrder };
          }
          return person;
        })
      );
    } catch (error) {
      console.error('Error updating order:', error);
      // Refresh the data to ensure consistency
      fetchProfiles();
    }
  };

  // Handle delete profile
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this profile?')) {
      try {
        await axios.delete(`${Base_Url}/profile/${id}`);
        setPeople(prevPeople => prevPeople.filter(person => person.id !== id));
      } catch (error) {
        console.error('Error deleting profile:', error);
      }
    }
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">CSC People</h5>
            <Link to="/add-profile" className="btn btn-primary btn-sm">
              Add New Profile
            </Link>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover table-bordered">
              <thead className="table-light">
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">UserID</th>
                  <th scope="col">Designation</th>
                  <th scope="col">
                    <div className="d-flex align-items-center cursor-pointer" onClick={() => sortPeople('order')}>
                      Order
                      <FaSort className="ms-1" />
                      {sortConfig.key === 'order' && (
                        <span className="ms-1 small">
                          {sortConfig.direction === 'asc' ? '↑' : '↓'}
                        </span>
                      )}
                    </div>
                  </th>
                  <th scope="col">HOD Status</th>
                  <th scope="col">Show in Display</th>
                  <th scope="col">Retired</th>
                  <th scope="col">IRD</th>
                  <th scope="col">Outsourced</th>
                  <th scope="col">Technical Staff</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedPeople.map((person) => (
                  <tr key={person.id} className={person.show_hod ? 'table-primary' : ''}>
                    <td>{person.id}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        {person.image_path && (
                          <img 
                            src={`${Base_Url}/${person.image_path}`} 
                            alt={person.name}
                            className="rounded-circle me-2"
                            style={{ width: '30px', height: '30px', objectFit: 'cover' }}
                          />
                        )}
                        <div className="d-flex align-items-center">
                          {person.name} 
                          {person.show_hod == 1 && (
                            <FaUserTie className="ms-2 text-primary" title="Head of Department" />
                          )}
                          {person.technicalstaff == 1 && (
                            <FaCogs className="ms-2 text-success" title="Technical Staff" />
                          )}
                        </div>
                      </div>
                    </td>
                    <td className='text-lowercase'>{person.userid}</td>
                    <td>{person.designation}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={person.order || '0'}
                        onChange={(e) => handleOrderChange(person.id, e.target.value)}
                        style={{ width: '60px' }}
                        min="0"
                      />
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className={`badge ${person.show_hod ? 'bg-primary' : 'bg-secondary'}`}>
                          {person.show_hod ? 'HOD' : 'Faculty'}
                        </span>
                        <div className="ms-2">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={person.show_hod}
                              onChange={() => handleToggle(person.id, 'show_hod')}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className={`badge ${person.show_in_display ? 'bg-success' : 'bg-danger'}`}>
                          {person.show_in_display ? 'Yes' : 'No'}
                        </span>
                        <div className="ms-2">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={person.show_in_display}
                              onChange={() => handleToggle(person.id, 'show_in_display')}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className={`badge ${person.isretired ? 'bg-warning' : 'bg-info'}`}>
                          {person.isretired ? 'Retired' : 'Active'}
                        </span>
                        <div className="ms-2">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={person.isretired}
                              onChange={() => handleToggle(person.id, 'isretired')}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className={`badge ${person.ird ? 'bg-success' : 'bg-secondary'}`}>
                          {person.ird ? 'Yes' : 'No'}
                        </span>
                        <div className="ms-2">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={person.ird}
                              onChange={() => handleToggle(person.id, 'ird')}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className={`badge ${person.outsource ? 'bg-success' : 'bg-secondary'}`}>
                          {person.outsource ? 'Yes' : 'No'}
                        </span>
                        <div className="ms-2">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={person.outsource}
                              onChange={() => handleToggle(person.id, 'outsource')}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className={`badge ${person.technicalstaff ? 'bg-success' : 'bg-secondary'}`}>
                          {person.technicalstaff ? 'Yes' : 'No'}
                        </span>
                        <div className="ms-2">
                          <div className="form-check form-switch d-inline-block">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={person.technicalstaff}
                              onChange={() => handleToggle(person.id, 'technicalstaff')}
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <Link
                          to={`/edit-profile/${person.id}`} 
                          className="btn btn-sm btn-outline-primary"
                        >
                          <FaEdit />
                        </Link>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(person.id)}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveTable;